import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap'
import CmsFeaturedSellerBioService from 'domains/cms-featured-seller/services/bio-service'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  featured_seller: PropTypes.shape({
    seller: PropTypes.shape({
      id       : PropTypes.number,
      name     : PropTypes.string,
      username : PropTypes.string,
      url_key  : PropTypes.string
    }),
    bio                                 : PropTypes.string,
    occupation                          : PropTypes.string,
    hero_image_url                      : PropTypes.string,
    hero_video_url                      : PropTypes.string,
    favourite_brand_thumbnail_image_url : PropTypes.string,
    inspired_look_thumbnail_image_url   : PropTypes.string
  })
}

const defaultProps = {
  featured_seller: {
    seller: {
      id       : 0,
      name     : 'Seller Name',
      username : '',
      url_key  : ''
    },
    bio                                 : 'Bio',
    occupation                          : 'Occupation',
    hero_image_url                      : '',
    hero_video_url                      : '',
    favourite_brand_thumbnail_image_url : '',
    inspired_look_thumbnail_image_url   : ''
  }
}

/**
 * Layout to preview CMS Featured Seller in create-and-edit page
 */

const CmsFeaturedSellerPreviewSection = ({
  featured_seller
}) => (
  <Card>
    <CardHeader>
      <h2>PREVIEW</h2>
    </CardHeader>
    <CardBody>
      <Row>
        <Col lg='12' style={{ backgroundColor: 'gray' }}>
          <h3 className='text-center'>Header</h3>
        </Col>
      </Row>
      <Row className='pt-4'>
        <Col lg='6' className='p-0' style={{ minHeight: '150px', backgroundColor: 'aqua', textAlign: 'center' }}>
          {
            featured_seller.hero_image_url ?
              <img src={ `${featured_seller.hero_image_url}` }  style={{ width: '100%' }} alt=''/>
              :
              <h3 className='text-center' style={{ paddingTop: '55px' }}>Cover Image</h3>
          }
        </Col>
        <Col lg='6'>
          <Row className='ml-2' style={{ height: '20px' }}>
            {
              <h3 className='text-center'>{ `${featured_seller.seller.name}` }</h3>
            }
          </Row>
          <Row className='mt-2 ml-2' style={{ height: '20px' }}>
            {
              <h4 className='text-center'>{ `${featured_seller.occupation}` }</h4>
            }
          </Row>
          {
            <Row className='mt-2 ml-2' style={{ height: '85px' }}>
              <p>{ CmsFeaturedSellerBioService.format(featured_seller.bio) }</p>
            </Row>
          }

        </Col>
      </Row>
      <Row className='mt-4'>
        <Col lg='4' style={{ height: '450px', backgroundColor: '#808080b8' }}>
          <h3 className='text-center' style={{ paddingTop: '225px' }}>Product Filter</h3>
        </Col>
        <Col lg='8' style={{ height: '450px', backgroundColor: '#80808082' }}>
          <h3 className='text-center' style={{ paddingTop: '225px' }}>Product List</h3>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col lg='6' className='p-0' style={{  minHeight: '100px', backgroundColor: 'aqua' }}>
          {
            featured_seller.favourite_brand_thumbnail_image_url ?
              <img src={ `${featured_seller.favourite_brand_thumbnail_image_url}` } style={{ width: '100%' }} alt=''/>
              :
              <h3 className='text-center' style={{ paddingTop: '25px' }}>Favourite Brand Thumbnail Image</h3>
          }
        </Col>
        <Col lg='6' className='p-0' style={{ minHeight: '100px', backgroundColor: '#00ff4e' }}>
          {
            featured_seller.inspired_look_thumbnail_image_url ?
              <img src={ `${featured_seller.inspired_look_thumbnail_image_url}` } style={{ width: '100%' }} alt=''/>
              :
              <h3 className='text-center' style={{ paddingTop: '25px' }}>Inspired Look Thumbnail Image</h3>
          }
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col lg='12' style={{ height: '30px', backgroundColor: 'gray' }}>
          <h3 className='text-center'>Footer</h3>
        </Col>
      </Row>
    </CardBody>
  </Card>
)

CmsFeaturedSellerPreviewSection.propTypes    = propTypes
CmsFeaturedSellerPreviewSection.defaultProps = defaultProps

export default CmsFeaturedSellerPreviewSection
